import type { RouteRecordRaw } from 'vue-router'

const actionsRoutes: RouteRecordRaw[] = [
  {
    path: '/actions',
    name: 'actions.index',
    component: () => import('@/modules/actions/views/ActionsIndex.vue'),
    meta: {
      pageTitle: 'My Actions',
      breadcrumbs: ['My Actions']
    }
  }
]

export default actionsRoutes
